import { render, staticRenderFns } from "./RulesOverview.vue?vue&type=template&id=cf85583c&scoped=true&"
import script from "./RulesOverview.vue?vue&type=script&lang=ts&"
export * from "./RulesOverview.vue?vue&type=script&lang=ts&"
import style0 from "./RulesOverview.vue?vue&type=style&index=0&id=cf85583c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf85583c",
  null
  
)

export default component.exports